export default "__VITE_ASSET__BbHn$rcU__"